module.exports = __webpack_public_path__ + "b5a4f8ecd2f13c06595fde19b1e8023e.svg";